<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import CarList from '@/components/CarList.vue';
import CarSlider from '@/components/CarSlider.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isStock: {
    type: Boolean,
    default: false,
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  items,
  hasTitle,
  hasItems,
  hasAnyContent,
  template,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="cars">
        <h2
          v-if="hasTitle"
          :class="[
            'mb-0 cars__title h2 text-center',
            backgroundColor === 'black' ? 'white' : 'black',
          ]"
          data-aos="fade-in"
          data-aos-delay="100"
          v-html="title"
        ></h2>
        <template v-if="hasItems">
          <CarList
            v-if="template === 'list'"
            :items="items"
            :background-color="backgroundColor"
            :is-stock="isStock"
          />
          <CarSlider
            v-else
            :items="items"
            :background-color="backgroundColor"
            :is-stock="isStock"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.cars {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
  }
  &__items {
    align-items: start;
    display: grid;
    flex-direction: column;
    gap: 56px;
    @include media-breakpoint-up(sm) {
      column-gap: 16px;
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(3, 1fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(column-gap, 16);
      @include responsive-spacing(row-gap, 56);
    }
  }
  &:deep(.car-item) {
    position: relative;
    padding-top: 56px;
    &:before {
      background-color: $divider;
      content: '';
      height: 1px;
      left: 0;
      position: absolute;
      top: 0px;
      right: 0;
      width: 100%;
    }
    &:first-child {
      padding-top: 0;
      &:before {
        display: none;
      }
    }
    @include media-breakpoint-up(sm) {
      &:nth-child(2) {
        padding-top: 0;
        &:before {
          display: none;
        }
      }
    }
    @include media-breakpoint-up(md) {
      &:nth-child(3) {
        padding-top: 0;
        &:before {
          display: none;
        }
      }
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-top, 56);
    }
  }
}
</style>
